import i18n from '@/i18n'
// 2026-07-23 15:30：翻译键不存在时回退原始文案，避免界面和操作日志出现 msg.route.*。
export const generateTitle = (title: any): string => {
  const originalTitle = title == null ? '' : String(title)
  const translationKey = 'msg.route.' + originalTitle
  return originalTitle && i18n.global.te(translationKey)
    ? i18n.global.t(translationKey)
    : originalTitle
}
